<template>
  <div class="form-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FormGroup'
}
</script>

<style scoped lang="scss">
.form-group {
  display: grid;
  grid-row-gap: 32px;
}
</style>
